import LocalStorageHelper from "models/helper/LocalStorageHelper";
import ExpectedError from "models/helper/ExpectedError";
import ti18n from "i18n!nls/helperi18n";

// null is intentional legacy personal storage; undefined means not resolved yet.
const WorkspaceScope = {
    requireResolved: function(workspaceId) {
        if (workspaceId === null || (typeof workspaceId === "string" && workspaceId.trim())) {
            return workspaceId;
        }
        throw new ExpectedError(window.getI18n(ti18n, "UPLOAD_WORKSPACE_UNAVAILABLE"));
    },

    capture: function(options) {
        if (options && Object.prototype.hasOwnProperty.call(options, "workspaceId")) {
            return this.requireResolved(options.workspaceId);
        }
        const storage = LocalStorageHelper.getInstance();
        const context = storage.getWorkspaceContext();
        if (context && context.workspaceId) {
            return this.requireResolved(context.workspaceId);
        }
        // A removed/stale workspace is not a request to save into personal storage.
        return this.requireResolved(storage.getCurrentWorkspaceId() ? undefined : null);
    },
};

export default WorkspaceScope;
